export default "__VITE_ASSET__Bm9Ksta0__"